module.exports = __webpack_public_path__ + "static/media/Du an dau tu xay dung.7e14f2c7.png";